import type {
  RecommendationSelectOptionItemData,
  RecommendationSelectOptionItemValue,
  RecommendationSelectProps,
} from "./recommendation-select.type";

import { useTranslation } from "react-i18next";

import QueryableSelect from "@/modules/queryable-select";

import { RecommendationSelectOption } from "./recommendation-select-option";

export const RecommendationSelect = ({
  hideLabel,
  onChange,
  ...props
}: RecommendationSelectProps) => {
  const { t } = useTranslation();
  const label = t("global:recommendation");

  return (
    <QueryableSelect<
      RecommendationSelectOptionItemValue,
      RecommendationSelectOptionItemData
    >
      name="recommendation"
      model="recommendations"
      filterBy="name"
      fields={["id", "name"]}
      label={hideLabel ? undefined : label}
      placeholder={label}
      optionFormat={RecommendationSelectOption}
      onChange={(value: unknown) => {
        onChange?.(value as RecommendationSelectOptionItemValue);
      }}
      {...props}
    />
  );
};
